import { NavigateFunction } from "react-router";
import { PaginatedResultMetaData } from "./Global.model";

export interface IHandleGetOrdersHistoryParams {
  token: string;
  setLoading: (v: boolean) => void;
  setApiError: (v: string | null) => void;
  onAuthError: (msg: string) => void;
  showPopup: (message: string) => void;
  navigate: NavigateFunction;
  setOrders: (orders: IOrderCardProps[]) => void;
}

export type OrdersHistoryResponse = {
  meta: PaginatedResultMetaData,
  data:{
    orders: IOrderCardProps[]
  }
}

export type OrderStatus =
  | 'PENDING'
  | 'PROCESSING'
  | 'SHIPPED'
  | 'DELIVERED'
  | 'CANCELED'
  | 'RETURNED';

export interface IOrderCardProps {
  id: string;
  orderNumber: string;
  itemsCount: number;
  totalToBePaid: number;
  createdAt: string;
  status: OrderStatus;
}

export type OrderStatusOption = {
  value: OrderStatus;
  label: string;
};

export const ORDER_STATUS_OPTIONS: OrderStatusOption[] = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'PROCESSING', label: 'Processing' },
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'CANCELED', label: 'Canceled' },
  { value: 'RETURNED', label: 'Returned' },
];

export interface IOrderStatusFilterDropdownProps {
  value: OrderStatus[];
  onChange: (next: OrderStatus[]) => void;
  disabled?: boolean;
}

export interface IOrdersListProps {
  orders: IOrderCardProps[];
  loading?: boolean;
  apiError?: string | null;
}

export type OrderDetailsItem = {
  id: string;
  itemId: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  name: string;
  imageUrl: string | null;
};

export type OrderDetails = {
  id: string;
  orderNumber: string;
  status: OrderStatus;
  createdAt: string;
  lastModifiedAt: string;
  totalToBePaid: number;
  deliveryCost: number;

  paymentMethod: { id: string; name: string };

  deliveryCarrier: {
    id: string;
    name: string;
    icon: string;
    deliveryTimeEstimation: string;
    fees: number;
  };

  deliveryAddress: {
    id: string;
    addressLabel: string;
    street: string;
    houseNumber: string;
    city: string;
    region: string;
    country: string;
    postalCode: string | null;
    additionalInformation: string | null;
    isDefaultAddress: boolean;
  };

  items: OrderDetailsItem[];
};

export interface IHandleGetOrderDetailsParams {
  token: string;
  orderId: string;
  setLoading: (v: boolean) => void;
  setApiError: (v: string | null) => void;
  onAuthError: (msg: string) => void;
  onForbidden?: (msg: string) => void;
  setOrder: (order: OrderDetails) => void;
}

